<template>
  <v-list
      class="with-white-spaces"
      dense
  >
    <v-list-item
        class="px-0"
        two-line
    >
      <v-list-item-avatar>
        <v-icon>mdi-help-circle-outline</v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="grey--text text--darken-2"><b>{{title}}</b></v-list-item-title>
        <v-list-item-subtitle v-html="description"></v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  name: 'PageInfo',
  props: {
    title: {
      required: true,
      type: String
    },
    description: {
      required: true,
      type: String
    }
  }
}
</script>

<style scoped>

</style>